// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen {
    display: flex;
    align-items: flex-start;
}

.half {
    width: 50vw;
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
}

.createButton {
    position: absolute;
    bottom: 40px;
    left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/CreateExercise/CreateExerciseScreen.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb","sourcesContent":[".screen {\n    display: flex;\n    align-items: flex-start;\n}\n\n.half {\n    width: 50vw;\n    display: flex;\n    gap: 24px;\n    flex-wrap: wrap;\n}\n\n.createButton {\n    position: absolute;\n    bottom: 40px;\n    left: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
